const T_PREFIX = "chat";

export const chatTrns = {
  title: `${T_PREFIX}.title`,
};

export const metaTrns = {
  title: `${T_PREFIX}.meta.title`,
  description: `${T_PREFIX}.meta.description`,
};
